import styled from "styled-components";

export const FormWrapper = styled.li`
  background-color: lightgray;
  width: 90%;
  margin: 0 auto 2rem;
  border-radius: 5px;
`;

export const StyledForm = styled.form`
  border: 1px solid;
  display: flex;
  flex-wrap: wrap;

  input,
  select {
    padding: 0.5rem;
    font-size: 1.6rem;
    flex: 1 1 25%;
  }

  textarea {
    font-size: 1.6rem;
    flex-basis: 100%;
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  flex: 1 1 50%;
`;

// props 에 따라 색깔 다르게
export const SubmitButton = styled.button`
  width: 100%;

  background-color: ${(props) =>
    props.btnType === "Add" ? "rgb(122, 214, 99)" : "rgb(201, 82, 82)"};

  border: none;
  padding: 1rem;
  cursor: pointer;
  display: flex;
  font-size: 1.4rem;
  justify-content: center;
  align-items: center;
  color: whitesmoke;
  &:hover {
    opacity: 0.8;
  }
`;
